// Libraries
var React = require('react');
var $ = require('jquery');
var debounce = require('lodash/debounce');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
require('./SponsorsMdc.scss');

class SponsorsMdcModule extends React.Component {

	constructor(props) {
		super(props);
		this.isCarouselInitialised = false;
		this.logosWidth = 0;
		this.$scroller = null;
	}

	toggleCarousel() {

		// If there are more logos than can sit inside
		// the div, we initialise the carousel.
			if (this.$scroller.outerWidth() < this.logosWidth
				&& !this.isCarouselInitialised) {

				this.$scroller.slick({
					arrows: false,
					dots: false,
					speed: 15000,
					autoplay: true,
					autoplaySpeed: 0,
					cssEase: 'linear',
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: true,
					infinite: true,
					draggable: false,
					pauseOnFocus: false,
					pauseOnHover: false,
					touchMove: false
				});

				this.isCarouselInitialised = true;

			} else if (this.$scroller.outerWidth() >= this.logosWidth
				&& this.isCarouselInitialised) {

				this.$scroller.slick("unslick");
			}
	}

	componentDidMount() {
		// Load the carousel lib when DOM is available.
			require('slick-carousel');

		// We create a new reference to the carousel, outside React.
			this.$scroller = $(this.scroller);

		// Debounced function for viewport resizing.
			let debouncedFunc = debounce(() => {
				this.toggleCarousel();
			}, 1000, {
				'leading': false,
				'trailing': true
			});

		// Wait for the images to load to get the right width.
			$(window).on("load", () => {

				// Get the total width of the logos.
					this.logosWidth = this.$scroller
					.find(".SponsorsMdc__sponsors__logo").toArray()
					.reduce(function(sum, el) {
						return sum + $(el).outerWidth();
					}, 0);

				debouncedFunc();
			});

		// On window resize, create/destroy the carousel.
			$( window ).resize(() => {
				debouncedFunc();
			});
	};

	shouldComponentUpdate() {
		return false;
	}

	render() {
		return (
			<div className="SponsorsMdc">

				<div className="SponsorsMdc__title">{this.props.data.sponsorsLabel}</div>
				<div className="SponsorsMdc__sponsors">
					<div className="SponsorsMdc__sponsors__container" ref={(scroller) => { this.scroller = scroller; }}>
						{this.props.data.sponsors.map((item, index) => {
							let element = item.link != null ?
								<a href={item.link.url} target={item.link.newWindow ? "_blank" : "_self"} rel={item.link.newWindow ? "noopener noreferrer" : undefined}><img src={PlaceholderImg} data-src={item.image.smallUrl} alt={item.image.altText} /></a>
								: <img src={PlaceholderImg} data-src={item.image.smallUrl} alt={item.image.altText} />;

							return (
								<div className={"SponsorsMdc__sponsors__logo"} key={index}>
									{element}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		)
	}
}

module.exports = SponsorsMdcModule;



// WEBPACK FOOTER //
// ./src/components/MDC/SponsorsMdc/SponsorsMdcModule.js